import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, Phone, Droplets } from "lucide-react";
import { churchInfo } from "../mock";

const navItems = [
  { label: "Home", to: "/" },
  { label: "What We Believe", to: "/what-we-believe" },
  { label: "Sermons", to: "/videos" },
  { label: "Staff", to: "/staff" },
  { label: "Prayer", to: "/#prayer" },
  { label: "Visit", to: "/#visit" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const handleNav = (to) => (e) => {
    if (to.includes("#")) {
      e.preventDefault();
      const [path, hash] = to.split("#");
      if (path && location.pathname !== path) {
        navigate(path);
        setTimeout(() => {
          const el = document.getElementById(hash);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 80);
      } else {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur border-b border-[#e8ecef] shadow-[0_2px_24px_-12px_rgba(10,45,56,0.1)]"
          : "bg-transparent"
      }`}
    >
      <div className="hidden md:flex items-center justify-between text-xs px-8 py-2 border-b border-white/10"
        style={{ color: scrolled ? "#4d6068" : "#faf7f2" }}>
        <div className="flex items-center gap-5">
          <span className="flex items-center gap-2"><Phone className="h-3.5 w-3.5" />{churchInfo.phone}</span>
          <span className="opacity-70">{churchInfo.address}</span>
        </div>
        <div className="flex items-center gap-4 text-xs tracking-[0.2em] uppercase font-semibold opacity-80">
          <span>“Come to the waters.” — Isaiah 55:1</span>
        </div>
      </div>

      <div className="flex items-center justify-between px-5 md:px-8 py-4">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src={scrolled ? "/brand/logo-dark-192.png" : "/brand/logo-light-192.png"}
            alt="First Assembly Living Waters"
            className="h-12 w-12 md:h-14 md:w-14 object-contain rounded-full"
          />
          <div className="leading-tight">
            <div className={`text-lg md:text-xl font-bold tracking-tight ${scrolled ? "text-[#0a2d38]" : "text-white"}`}>
              Living Waters
            </div>
            <div className={`text-[10px] md:text-[11px] uppercase tracking-[0.22em] ${scrolled ? "text-[#7a8a8f]" : "text-white/80"}`}>
              First Assembly • Big Spring, TX
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              onClick={handleNav(item.to)}
              className={`text-sm font-medium tracking-wide transition-colors hover:text-[#c8a36a] ${
                scrolled ? "text-[#1c2b30]" : "text-white"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={churchInfo.donateUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-gold rounded-full px-5 py-2 text-sm font-semibold"
          >
            Give Online
          </a>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden p-2 rounded-md ${scrolled ? "text-[#0a2d38]" : "text-white"}`}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#e8ecef] px-6 py-4">
          <div className="flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={handleNav(item.to)}
                className="py-2 text-[#1c2b30] font-medium border-b border-[#e8ecef] hover:text-[#c8a36a]"
              >
                {item.label}
              </Link>
            ))}
            <a href={churchInfo.donateUrl} target="_blank" rel="noreferrer" className="btn-gold rounded-full px-5 py-2 text-sm font-semibold mt-2 text-center">
              Give Online
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
